module.exports = __webpack_public_path__ + "img/Togo.951484b4.svg";